import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { wsGetAll } from 'services/WService';

import Modal from 'components/Tvendo/Common/ModalBase';

export default function ModalLine(props) {
  const line = props.model;
  const [dataChanging, setDataChanging] = useState(line);
  const [categories, setCategories] = useState([]);

  async function listCategories() {
    let response = await wsGetAll('logi/category');
    if (response.success) setCategories(response.data);
  }

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  useEffect(() => {
    listCategories();
  }, []);

  return (
    <Modal
      title="Líneas"
      model={line}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="logi/line"
      state
    >
      <TextField
        label="Código"
        fullWidth
        type="text"
        name="code"
        margin="normal"
        defaultValue={!!line ? line.code : ''}
        required
      />
      <TextField
        label="Descripción"
        fullWidth
        type="text"
        name="description"
        margin="normal"
        defaultValue={!!line ? line.description : ''}
        required
      />
      <Autocomplete
        options={categories}
        getOptionLabel={(option) => option.description}
        defaultValue={
          !!line ? categories.find((category) => category.id == line.logi_category_id) : undefined
        }
        renderInput={(params) => (
          <TextField {...params} label="Categoría" margin="normal" required />
        )}
        onChange={(e, item) => {
          if (!!item) {
            return handleChange('logi_category_id', item.id);
          }
          handleChange('logi_category_id', null);
        }}
      />
    </Modal>
  );
}
